import { render, staticRenderFns } from "./EditorialArticle.vue?vue&type=template&id=6d348bd3&scoped=true"
import script from "./EditorialArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorialArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditorialArticle.vue?vue&type=style&index=0&id=6d348bd3&prod&lang=scss&scoped=true"
import style1 from "./EditorialArticle.vue?vue&type=style&index=1&id=6d348bd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d348bd3",
  null
  
)

export default component.exports